import { IShipmentMissingInfo } from 'types/FMSGraphqlTypes'
import { MISSING_INFORMATION_LABELS_MAPPER } from '../../../constants'

interface IGetMissingInformationLabelProps {
  missingInformation: IShipmentMissingInfo[]
}

export const getMissingInformationLabel = ({
  missingInformation,
}: IGetMissingInformationLabelProps): string => {
  if (missingInformation.length === 0) {
    return ''
  }

  const isPodRejected = missingInformation.includes(IShipmentMissingInfo.PodRejected)
  const missingInfo =
    missingInformation.filter(info => info !== IShipmentMissingInfo.PodRejected) || []
  const infoNeeded = missingInfo.map(info => MISSING_INFORMATION_LABELS_MAPPER[info])
  const infoNeededLabel = infoNeeded.length > 0 ? `${infoNeeded.join(', ')} Needed` : ''

  if (!isPodRejected) {
    return infoNeededLabel
  }

  const podRejectedLabel = `${
    MISSING_INFORMATION_LABELS_MAPPER[IShipmentMissingInfo.PodRejected]
  } Rejected`

  return infoNeededLabel ? `${infoNeededLabel}, ${podRejectedLabel}` : podRejectedLabel
}
